import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import SearchableDropdown from "../../../../Core/Fields/Floating/SearchableDropdown";
import GetIcon from "../../../../utils/Icon";

const TableTab3 = ({
  setselected_tax_item_data,
  list_itemtax_data,
  list_item_tax_category_data,
  po_status,
}) => {
  // ✅ use pageState binding like TableTab2
  const { value: rows = [], setValue = () => {} } = setselected_tax_item_data || {};

  const tableRef = useRef();
  const dropdownRef = useRef(null);
  const dropdownRef1 = useRef(null);

  const [rowsPerPage] = useState(10);

  // Dropdown states
  const [offset, setOffset] = useState(0);
  const [search_input, setsearch_input] = useState("");
  const [offset1, setOffset1] = useState(0);
  const [search_input1, setsearch_input1] = useState("");

  const [hasMore, setHasMore] = useState(true);
  const [hasMoreCategory, setHasMoreCategory] = useState(true);

  const [item_tax_list, setitem_tax_list] = useState([]);
  const [item_tax_category_list, setitem_tax_category_list] = useState([]);

  // UI states
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
  const [showDropdown, setShowDropdown] = useState({ rowIndex: null, field: null });

  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allRowIndices = rows.map((_, index) => index);
      setSelectedRows(allRowIndices);
    } else {
      setSelectedRows([]);
    }
  };

  // ✅ deep clone before update (same as TableTab2)
  const deepClone = (obj) => JSON.parse(JSON.stringify(obj));

  const updateRow = (index, field, value) => {
    const updatedRows = rows.map((row, i) =>
      i === index
        ? {
            ...deepClone(row),
            item: { ...(row.item || {}), [field]: value },
          }
        : row
    );
    setValue(updatedRows);
  };

  const toggleRowSelection = (index) => {
    setSelectedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const createNewRow = () => ({
    item: {
      item_tax_template: "",
      tax_category: "",
      valid_from: "",
      minimum_net_rate: "",
      maximum_net_rate: "",
    },
  });

  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setValue(newRows); // ✅ update via pageState
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    if (currentPage !== lastPage) setCurrentPage(lastPage);
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setValue(updatedRows); // ✅ update via pageState
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  };

  // --- API calls ---
  const getItemTaxdata = async (newOffset = 0, searchText = "") => {
    const res = await list_itemtax_data({ start: newOffset, search_input: searchText });
    const products = res?.data?.data || [];
    if (newOffset === 0) {
      setitem_tax_list(products);
    } else {
      setitem_tax_list((prev) => [...prev, ...products]);
    }
    setHasMore(products.length === 20);
  };

  const getItemtax_categorydata = async (newOffset = 0, searchText = "") => {
    const res = await list_item_tax_category_data({ start: newOffset, search_input: searchText });
    const products = res?.data?.data || [];
    if (newOffset === 0) {
      setitem_tax_category_list(products);
    } else {
      setitem_tax_category_list((prev) => [...prev, ...products]);
    }
    setHasMoreCategory(products.length === 20);
  };

  useEffect(() => {
    getItemTaxdata(0, "");
    getItemtax_categorydata(0, "");
  }, []);

  // --- resizable headers (same logic as TableTab2) ---
  useEffect(() => {
    const cols = tableRef.current?.querySelectorAll("th");
    cols?.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

  return (
    <div className="">
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {[
              "Action",
              "S.No",
              "Item Tax Template",
              "Tax Category",
              "Valid From",
              "Minimum Net Rate",
              "Maximum Net Rate",
              <GetIcon iconName="PiSlidersHorizontalBold" size={12} />
            ].map((title, i) => {
              const isIcon = typeof title !== "string";
              const defaultWidths = {
                Action: "54px",
                "S.No": "54px",
                "Item Tax Template": "202px",
                "Tax Category": "202px",
                "Valid From": "202px",
                "Minimum Net Rate": "202px",
                "Maximum Net Rate": "202px",
                Action1: "202px",
              };

              return (
                <th
                  key={i}
                  style={{
                    fontSize: "7px",
                    position: "relative",
                    textAlign:
                      title === "Action" ||
                      title === "S.No" ||
                      title === "isIcon"
                        ? "center"
                        : "center",

                    width:
            typeof title === "string" ? defaultWidths[title] || "202px" : "202px",
          minWidth:
            typeof title === "string" ? defaultWidths[title] || "202px" : "202px",
                  }}
                >
                  {title === "Action" ? (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      style={{
                        backgroundColor: isAllSelected ? "#270b79" : "",
                        borderColor: isAllSelected ? "#270b79" : "",
                        fontSize: "15px",
                      }}
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  ) : isIcon ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            {title}
          </div>
        ) : (
          title
        )}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            return (
              <tr key={globalIndex}>
                <td className="p-0" style={{ cursor: "pointer" }}>
                  <p
                    className="m-0"
                    style={{ position: "relative", top: "5px" }}
                  >
                    {selectedRows.includes(globalIndex) ? (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{
                            backgroundColor: "#270b79",
                            fontSize: "15px",
                            borderColor: "#270b79",
                          }}
                          checked
                        />
                      </span>
                    ) : (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ fontSize: "15px" }}
                        />
                      </span>
                    )}
                  </p>
                </td>
                <td
                  style={{
                    textAlign: "center",
                    fontSize: '0.8rem',textAlign: "center",
                    padding: "0.5rem",
                  }}
                >
                  {globalIndex + 1}
                </td>
<td className="p-0">
 <SearchableDropdown
  globalIndex={globalIndex}
  field="item_tax_template"
  value={row.item?.item_tax_template || row.item_tax_template || ""}
  onChange={(val) => updateRow(globalIndex, "item_tax_template", val)}
  onSearch={(text) => getItemTaxdata(0, text)}
  dropdownData={item_tax_list}
  placeholder="Select Item Tax Template"
  focusedCell={focusedCell}
  setFocusedCell={setFocusedCell}
  showDropdown={showDropdown}
  setShowDropdown={setShowDropdown}
  dropdownRef={dropdownRef}
  setOffset={setOffset}
  offset={offset}
  search_input={search_input}
  hasMore={hasMore}
  getData={getItemTaxdata}
     createNewUrl="/master/itemtax/create-item-tax"
  createNewLabel="+ Create Item Tax Template"
/>


</td>

<td className="p-0">
  <SearchableDropdown
  globalIndex={globalIndex}
  field="tax_category"
  value={row.item?.tax_category || row.tax_category || ""}
  onChange={(val) => updateRow(globalIndex, "tax_category", val)}
  onSearch={(text) => getItemtax_categorydata(0, text)}
  dropdownData={item_tax_category_list}
  placeholder="Select Tax Category"
  focusedCell={focusedCell}
  setFocusedCell={setFocusedCell}
  showDropdown={showDropdown}
  setShowDropdown={setShowDropdown}
  dropdownRef={dropdownRef1}
  setOffset={setOffset1}
  offset={offset1}
  search_input={search_input1}
  hasMore={hasMoreCategory}
  getData={getItemtax_categorydata}
  createNewUrl="/master/tax/create-tax"
  createNewLabel="+ Create Tax Category"
/>


 
</td>

                <td className="p-0" style={{ 
                      border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'valid_from' ? '0.3px solid #270b79' : '' 
                    }}
>
                  <input
                    type="date"
                     onFocus={() => setFocusedCell({ rowIndex: globalIndex, field: 'valid_from' })}
                    onBlur={() => setFocusedCell({ rowIndex: null, field: null })}
                    className="form-control tableinput noborder"
                    style={{ fontSize: '0.8rem',textAlign: "center" }}
                    value={row?.item?.valid_from ?? ""}
                    onChange={(e) =>
                      updateRow(globalIndex, "valid_from", e.target.value)
                    }
                  />
                </td>
                <td className="p-0 d-flex justify-content-center" style={{ 
                      border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'minimum_net_rate' ? '0.3px solid #270b79' : '' 
                    }}
>
                  <input
                    type="text"
                    placeholder="Minimum Net Rate"
                     onFocus={() => setFocusedCell({ rowIndex: globalIndex, field: 'minimum_net_rate' })}
                    onBlur={() => setFocusedCell({ rowIndex: null, field: null })}
                    className="form-control tableinput noborder"
                    style={{ fontSize: '0.8rem',textAlign: "center" }}
                    value={row?.item?.minimum_net_rate ?? ""}
                    onChange={(e) =>
                      updateRow(globalIndex, "minimum_net_rate", e.target.value)
                    }
                  />
                </td>
                <td className="p-0" style={{ 
                      border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'maximum_net_rate' ? '0.3px solid #270b79' : '' 
                    }}
>
                  <input
                    type="text"
                    placeholder="Maximum Net Rate"
                    onFocus={() => setFocusedCell({ rowIndex: globalIndex, field: 'maximum_net_rate' })}
                    onBlur={() => setFocusedCell({ rowIndex: null, field: null })}
                    className="form-control tableinput noborder"
                    style={{ fontSize: '0.8rem',textAlign: "center" }}
                    value={row?.item?.maximum_net_rate ?? ""}
                    onChange={(e) =>
                      updateRow(globalIndex, "maximum_net_rate", e.target.value)
                    }
                  />
                </td>

                <td
                  style={{
                    position: "relative",
                    width: "40px",
                  }}
                >
                  <img
                    src="/Maskgroup.png"
                    alt="edit"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "12px",
                      height: "12px",
                      pointerEvents: "none",
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div
        className="d-flex pb-2  justify-content-between align-items-center"
        style={{ marginTop: "12px", marginBottom: "16px" }}
      >
        <div className="d-flex" style={{ gap: "4px" }}>
          {selectedRows.length > 0 && (
            <Button
              onClick={handleDeleteSelectedRows}
              className="customdeletebtn "
              iconName="MdDeleteOutline"
              iconSize={12}
            >
              Delete
            </Button>
          )}
          {selectedRows.length == 0 && (
            <Button
              onClick={handleAddRow}
              className="Addrowdesign"
              iconName="FiPlus"
              iconSize={12}
              iconWrapperStyle={{
                backgroundColor: "#F6D593",
                padding: "1px",
                display: "flex",
              }}
            >
              Add Row
            </Button>
          )}
        </div>

        <div
          className={`${
            rows.length < 11 ? "d-none" : "d-flex"
          } align-items-center centerpagination`}
          style={{ gap: "5px" }}
        >
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={rows.length}
          />
        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: "12px", color: "#270B79" }}>
            Showing {indexOfFirstRow + 1} to{" "}
            {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
          </span>
        </div>
      </div>
    </div>
  );
};

export default TableTab3;
